import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export function createMuiDateLocalizationAdapter() {
  return AdapterDayjs;
}
